module.exports = "/dist/assets/8620776bc21b3e1b541174a207a4adf1.svg";